import { useRecoilState } from "recoil";
import { allCCTState, cctLoadContextState } from "../atoms/core";
import { useLazyQuery, useQuery } from "@apollo/client";
import { FIND_CCT, GET_CCT_BY_EDITION_BY } from "../graphql/cct";
import { useEffect } from "react";
import { useI18n } from "./i18n-hooks";
import { Contract } from "../__generated__/graphql";

/**
 * Load the CCTs for the given state code in the allCCTState recoil atom.
 * @param stateCode State code i.e. "VS"
 */
export const useLoadCCTs = (stateCode: string | undefined | null) => {
    const [cctLoadContext, setCctLoadContext] = useRecoilState(cctLoadContextState);
    const [_, setAllCcts] = useRecoilState(allCCTState);
    const [fetchCcts, { loading }] = useLazyQuery(FIND_CCT, { fetchPolicy: "cache-and-network" });
    const i18n = useI18n();
    useEffect(() => {
        if (
            stateCode &&
            (cctLoadContext.stateCode !== stateCode || cctLoadContext.locale !== i18n.locale)
        ) {
            setCctLoadContext({ stateCode, locale: i18n.locale });
            const func = async () => {
                const { data, error } = await fetchCcts({
                    variables: {
                        stateCode: stateCode,
                        limit: 100,
                    },
                });
                if (error) {
                    throw Error(i18n.t("screens.user.create_mission_cct.cannot_load"));
                }
                setAllCcts(data?.findCct?.elements);
            };
            void func();
        }
    }, [stateCode, cctLoadContext, fetchCcts, i18n, setAllCcts, setCctLoadContext]);
    return loading;
};

export const useContractCct = (contract?: Contract) => {
    const cct = useQuery(GET_CCT_BY_EDITION_BY, {
        variables: {
            cctEditionId: contract?.cctEditionId || "",
        },
        skip: !contract?.cctEditionId,
    });
    return cct?.data?.getCctByEditionId || null;
};
